import axios from "axios";
import { getBaseURLforBackEnd  , getConfigAxios } from '@/utils.js'
import master_data from "./master_data";
import {DateTime} from "luxon";



export default {
    namespaced: true,
    state: {
      
        dataDifferentialCounterLog : [],
     
        //firstTimeStart  : true,
        dateReqDifferentialCounterLog : null,
    },

    getters: {
    },

    mutations: {


        // setFirstTimeStart(state,firstTimeStart){
        //     state.firstTimeStart = firstTimeStart
        // },
        setDateReqDifferentialCounterLog(state,dateReqDifferentialCounterLog){
            state.dateReqDifferentialCounterLog = dateReqDifferentialCounterLog
        },
        setDataDifferentialCounterLog(state,dataDifferentialCounterLog){
            state.dataDifferentialCounterLog = dataDifferentialCounterLog
        },

         
         
         

    },

    actions: {
      

    

        fetchDataDifferentialCounterLog({commit,state}){
            const datTo =   {
                              "date_req" :   DateTime.utc((new Date( state.dateReqDifferentialCounterLog )).getFullYear(), (new Date( state.dateReqDifferentialCounterLog )).getMonth()+1, (new Date( state.dateReqDifferentialCounterLog  )).getDate()).toISO()  
                        }
            // console.log(JSON.stringify(datTo))  
            return new Promise((resolve,reject) => {
                axios.defaults.headers.common['Authorization'] = `Bearer  ${master_data.state.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/get_diffcountmachine_log`,datTo,getConfigAxios())
                    .then((res)=>{
                        commit('setDataDifferentialCounterLog',res.data) 
                        resolve(res.data)
                    })
                    .catch(err =>{
                        commit('setPatho_items',[])  
                        reject(err)
                    })
            })
        } ,



         


        
       


    }
}